<template>
    <div class="plugin_app" :style="{ zoom: zoom }">
        <label for="toggle1" class="toggle-label"><span class="flex-between"><img class="logo"
                    src="/web/image/logo0.png" />{{ $t('海澳PTE Academic查小分插件') }}</span></label>
        <div class="content">
            <div>{{ $t('PTE-雅思分数对应数据来自培生，但是每所学校分数可能所有不同。') }}</div>
            <div class="mt">
                <div class="flex-between">
                    <div class="b">Communicative Skills</div>

                    <div class="b">{{ $t('考试日期') }}: 2025-08-07</div>
                </div>
            </div>

            <div class="mt">
                <el-table class="border" size="small" :data="scoreData">
                    <el-table-column align="center" prop="name">
                    </el-table-column>
                    <el-table-column align="center" prop="total" label="Total">
                    </el-table-column>
                    <el-table-column align="center" prop="listening" label="Listening">
                    </el-table-column>
                    <el-table-column align="center" prop="reading" label="Reading">
                    </el-table-column>
                    <el-table-column align="center" prop="speaking" label="Speaking">
                    </el-table-column>
                    <el-table-column align="center" prop="writing" label="Writing">
                    </el-table-column>
                </el-table>
            </div>

            <div class="mt">
                <div class="b">Sub-Skills</div>
                <el-table class="border" style="margin-top: 10px;" size="small" :show-header="false" :data="subskills">
                    <el-table-column prop="name" width="270">
                        <template #default="scope">
                            {{ items[scope.$index] }}
                        </template>

                    </el-table-column>

                    <el-table-column>
                        <template #default="scope">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div style="flex: 1;">
                                    <div style="display: flex;gap:0 10px; flex-wrap: wrap;justify-content: flex-end;">
                                        <span v-for="(tag, index1) in tags[scope.$index].split(',')" :key="index1">{{
                                            tag }}</span>
                                    </div>
                                    <div>
                                        <el-progress color="#e6a13c" :percentage="scope.row.score / 90 * 100"
                                            :show-text="false" />
                                    </div>
                                </div>

                                <view style="margin-left: 20px;">
                                    <el-tag color="#e6a13c"><span style="color: #fff;font-weight: bold;">{{
                                        scope.row.score }}</span></el-tag>
                                </view>
                            </div>
                        </template>
                    </el-table-column>
                    <template #append>
                        <div class="b" style="padding: 10px;">-Note: Sub-skill scores have tolerance, a mark of 90
                            doesn't mean
                            100% accuracy for the
                            represented question types.</div>
                    </template>
                </el-table>

            </div>
            <div style="display: flex; justify-content: center;padding: 25px 0 0;pointer-events: none;">
                <el-button type="primary" round size="large"><span style="color: #fff;">{{
                    $t('一键导入海澳PTE官网，查看题型正确率详细评估') }}&nbsp;</span><el-icon color="#fff">
                        <i class="el-icon-right"></i>
                    </el-icon> </el-button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'pluginPopup',

    props: {
        zoom: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            checked: true,
            scoreData: [],
            testDate: '',
            items: [
                'Open Response Speaking and Writing',
                'Reproducing Spoken and Written Language',
                'Extended Writing',
                'Short Writing',
                'Extended Speaking',
                'Short Speaking',
                'Multiple-skills Comprehension',
                'Single-skill Comprehension'
            ],
            score: { gseScore: 90, listening: 90, reading: 90, speaking: 90, writing: 89, subskills: [{ score: 84 }, { score: 90 }, { score: 90 }, { score: 90 }, { score: 69 }, { score: 90 }, { score: 90 }, { score: 90 }] },
            tags: ['DI,RL,SGD,RTS,SWT,WE,SST', 'RA,RS,WFD', 'SWT,WE,SST', 'WFD', 'DI,RL,SGD,RTS', 'RA,RS', 'RS,RL,SGD,SWT,SST,HCS,HIW,WFD', 'ASQ,RTS,FIB-D,MCM-R,RO,FIB-DD,MCS-R,MCM-L,FIB-L,MCS-L,SMW'],
        }
    },
    created() {

        const response = { gseScore: 90, listening: 90, reading: 90, speaking: 90, writing: 89, subskills: [{ score: 84 }, { score: 90 }, { score: 90 }, { score: 90 }, { score: 69 }, { score: 90 }, { score: 90 }, { score: 90 }] }
        this.subskills = response.subskills || [];
        this.scoreData = [{
            name: 'PTE Academic',
            total: response.gseScore || 0,
            listening: response.listening || 0,
            reading: response.reading || 0,
            speaking: response.speaking || 0,
            writing: response.writing || 0,
        }]
        const ielts = this.calc(response)
        this.scoreData.push({
            name: 'IELTS Equal',
            total: ielts.score || 0,
            listening: ielts.listening || 0,
            reading: ielts.reading || 0,
            speaking: ielts.speaking || 0,
            writing: ielts.writing || 0,
        })
    },

    methods: {
        calc({ gseScore, listening, reading, speaking, writing }) {
            const pte = {
                score: gseScore,
                listening,
                reading,
                speaking,
                writing
            }
            const headers = ['value', 'score', 'listening', 'reading', 'speaking', 'writing'];
            const items = [
                [4.5, '24-30', '26-32', '29-35', '14-23', '17-28'],
                [5, '31-38', '33-39', '36-41', '24-38', '29-40'],
                [5.5, '39-46', '40-46', '42-47', '39-53', '41-50'],
                [6, '47-54', '47-52', '48-53', '54-65', '51-59'],
                [6.5, '55-62', '53-57', '54-58', '66-75', '60-68'],
                [7, '63-70', '58-63', '59-64', '76-82', '69-76'],
                [7.5, '71-78', '64-68', '65-69', '83-87', '77-84'],
                [8, '79-85', '69-74', '70-74', '88-89', '85-89'],
                [8.5, '86-89', '75-80', '75-80', '90', '90'],
                [9, '90', '81-90', '81-90', '', ''],
            ]
            let ielts = {}
            let index = -1;
            Object.keys(pte).forEach(key => {
                index = headers.indexOf(key)
                index = items.map(item => item[index]).findIndex(range => {
                    if (range) {
                        let [min, max] = range.split('-').map(Number);
                        if (max === undefined) {
                            max = min; // 如果没有范围，表示是一个具体值
                        }
                        if (pte[key] >= min && pte[key] <= max) {
                            return true;
                        }
                    }
                    return false
                });
                ielts[key] = items[index][0];
            })
            return ielts;
        },
    }
}






</script>

<style scoped>
.plugin_app {
    pointer-events: none;
    width: 800px;
    height: 880px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
}

.plugin_app>>>.el-table__row,
.plugin_app>>>.el-table th.el-table__cell {
    background-color: #ffffff !important;
    color: #333333 !important;
}

.plugin_app>>>.el-table--enable-row-hover{
    background-color: #ffffff !important;
}



.border {
    border: 1px solid #eee;
    border-radius: 10px;
}

.b {
    font-weight: bold;
}

.mt {
    margin-top: 10px;
}

.toggle-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px 20px;
    background: linear-gradient(to right, #FAD23F, #e6a13c);
    color: white;
    font-weight: 600;
    font-size: 18px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(106, 17, 203, 0.3);
    width: auto;
}

/* 

.toggle-label::after {
    content: '+';
    font-size: 1.5rem;
    margin-left: 10px;
    transform: rotate(45deg);
    transition: transform 0.3s ease;
} */


.content {
    width: 100%;
    height: auto;
    padding: 20px;
    /* box-shadow: 2px 2px 5px #e6a13c; */
    overflow: scroll;
    transition: all 0.3s ease;
    background: white;
    border: 1px solid #e6a13c;
    box-sizing: border-box;
}


.flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    border: 2px solid #ffffff;
}

.el-table--small {
    font-size: 14px !important;
}
</style>
